import Vue from 'vue';
import VueI18n from 'vue-i18n';
import locale from 'browser-locale';
import ZHTWLang from '../lang/zh-tw';
import ZHCNLang from '../lang/zh-cn';
import FRLang from '../lang/fr';
import ENLang from '../lang/en';
import KOLang from '../lang/ko';
import THLang from '../lang/th';
import JALang from '../lang/ja';
import VILang from '../lang/vi';
import DELang from '../lang/de';
import connector from './nativeInterface';

const msg = {
  en: ENLang,
  'fr-FR': FRLang,
  fr: FRLang,
  FR: FRLang,
  vi: VILang,
  Vi: VILang,
  VI: VILang,
  'fr-LU': FRLang,
  'fr-CH': FRLang,
  'fr-CA': FRLang,
  'fr-BE': FRLang,
  'fr-fr': FRLang,
  'fr-lu': FRLang,
  'fr-ch': FRLang,
  'fr-ca': FRLang,
  'fr-be': FRLang,
  'en-au': ENLang,
  'en-in': ENLang,
  'en-bz': ENLang,
  'en-ca': ENLang,
  'en-cb': ENLang,
  'en-ie': ENLang,
  'en-jm': ENLang,
  'en-nz': ENLang,
  'en-ph': ENLang,
  'en-za': ENLang,
  'en-tt': ENLang,
  'en-gb': ENLang,
  'en-us': ENLang,
  'en-zw': ENLang,
  'en-cn': ENLang,
  zh: ZHCNLang,
  'zh-cn': ZHCNLang,
  'zh-hk': ZHTWLang,
  'zh-mo': ZHTWLang,
  'zh-sg': ZHTWLang,
  'zh-tw': ZHTWLang,
  'zh-chs': ZHCNLang,
  'zh-cht': ZHTWLang,
  'zh-Hans': ZHCNLang,
  'zh-Hant': ZHTWLang,
  ko: KOLang,
  'ko-kr': KOLang,
  th: THLang,
  de: DELang,
  'th-th': THLang,
  ja: JALang,
  'ja-JP': JALang,

};
// console.log(connector.getDevice());

let language = (connector.getDevice().language) || locale().toLowerCase();
console.log(connector.getDevice().language);
// let language = locale().toLowerCase();
if (msg[language] === undefined) {
  if (language.indexOf('ko') >= 0) {
    language = 'ko';
  } else if (language.indexOf('th') >= 0) {
    language = 'th';
  } else if (language.indexOf('de') >= 0) {
    language = 'de';
  } else if (language.indexOf('fr') >= 0) {
    language = 'fr';
  } else if (language.indexOf('zh-Hans') >= 0) {
    language = 'zh-Hans';
  } else if (language.indexOf('zh-Hant') >= 0) {
    language = 'zh-Hant';
  } else if (language.indexOf('zh-cn') >= 0) {
    language = 'zh-cn';
  } else if (language.indexOf('ja') >= 0) {
    language = 'ja';
  } else if (language.indexOf('vi') >= 0) {
    language = 'vi';
  } else if (language.indexOf('en') >= 0) {
    language = 'en';
  } else {
    language = 'en';
  }
}

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: language,
  messages: msg,
});

export default i18n;



// WEBPACK FOOTER //
// ./src/common/js/i18n.js